import { motion } from 'framer-motion';
import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled(motion.div)`
    position: fixed;
    z-index: 98;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: #141327;
    padding: 20px 20px 60px;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
`;

export const CloseButton = styled.button`
    ${styledReset.button}

    height: 32px;
    padding: 0px 15px;

    display: flex;
    align-items: center;
    justify-content: center;

    align-self: center;
    justify-self: center;

    color: #fff;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.24px;
    flex-shrink: 0;

    border-radius: 40px;
    background: radial-gradient(67.31% 175% at 50% 148.75%, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0) 100%),
        rgba(255, 255, 255, 0.1);
`;
